/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'

import DeleteModal from '../../modals/deleteModal'
// import EditModal from '../../modals/editModal'
// import EditServiceModal from './editServiceModal'

function VendorActionButton(props) {
    const [categoryId, setCategoryId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)

    let handleDelete = () => {
        console.log("Delete Props", props.data)
        props.data.deleteVendor(props.data.transporterMasterId)
    }


    let handleEdit = (e) => {
        let vendor = props.data
        console.log("Edit Props", props)
        let history = props.agGridReact.props.baseURL.history
        history.push({ pathname: '/edit-partner' , state: { id: vendor.transporterMasterId }})
    }
   
    let handleOpenDelete = (e) => {
        let mainData = props.data
        setCategoryId(mainData.id)
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    return (
        <>
            <Button onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} /> 
        </>
    )
}

export default VendorActionButton
